import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

const app = firebase.initializeApp({
  // Previous APIKey

  apiKey: "AIzaSyD1nO6VhFsEBj8iQJo4waPz2Qh5MrbDYSw",
  authDomain: "brainy-nexto.firebaseapp.com",
  databaseURL: "https://brainy-nexto.firebaseio.com",
  projectId: "brainy-nexto",
  storageBucket: "brainy-nexto.appspot.com",
  messagingSenderId: "519911771127",
  appId: "1:519911771127:web:53ee0361f5399c746ebcf2",
  measurementId: "G-QF1PWCVSFR",

  
  // DEV API KEY

  // apiKey: "AIzaSyDjr5x5B5zkAOz1ZhShUtl0NBJ261Fglsc",
  // authDomain: "nexto-dev.firebaseapp.com",
  // databaseURL: "https://nexto-dev.firebaseio.com",
  // projectId: "nexto-dev",
  // storageBucket: "nexto-dev.appspot.com",
  // messagingSenderId: "752417246789",
  // appId: "1:752417246789:web:befa21e9d2c284ea6fdd2c",
  // measurementId: "G-L06TKDWMGC"
});

export default app;
